/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import { FormattedMessage } from 'react-intl';
import { Link, Redirect, Switch } from 'react-router-dom';

import { toAbsoluteUrl } from '../../../../_metronic/_helpers';
import { ContentRoute } from '../../../../_metronic/layout';
import { AUTH_RESET_CONFIRMATION_ROUTE, AUTH_RESET_ROUTE, AUTH_ROUTE, AUTH_SIGN_IN_ROUTE, AUTH_SIGN_UP_CONFIRMATION_ROUTE, AUTH_SIGN_UP_ROUTE } from '../routes';

import Reset from './reset';
import ResetConfirmation from './reset-confirmation';
import SignIn from './sign-in';
import SignUp from './sign-up';
import SignUpConfirmation from './sign-up-confirmation';

import '../../../../_metronic/_assets/sass/pages/login/classic/login-1.scss';

const currentYear = new Date().getFullYear();
const copyrightText = `${currentYear.toString()} DCI Grading`;

const useStyles = makeStyles(() => ({
  logoContainer: {
    display: 'flex',
    justifyContent: 'center',
  },
  logo: {
    aspectRatio: 'initial',
    maxWidth: '120px',
    width: '100%',
  },
}));

export function Auth() {
  const classes = useStyles();

  return (
    <>
      <div className="d-flex flex-column flex-root">
        {/*begin::Sign in*/}
        <div
          className="login login-1 login-signin-on d-flex flex-column flex-lg-row flex-column-fluid bg-white"
          id="kt_login"
        >
          {/*begin::Aside*/}
          <div
            className="login-aside d-flex flex-row-auto bgi-size-cover bgi-no-repeat p-10 p-lg-10"
            // style={{ backgroundImage: `url(${toAbsoluteUrl('/media/bg/bg-4.jpg')})` }}
            style={{ backgroundColor: `black` }}
          >
            {/*begin: Aside Container*/}
            <div className="d-flex flex-row-fluid flex-column justify-content-between">
              {/* start:: Aside header */}
              <Link to="/" className={`flex-column-auto mt-5 pb-lg-0 pb-10 ${classes.logoContainer}`}>
                <img
                  alt="Logo"
                  className={classes.logo}
                  src={toAbsoluteUrl('/media/dci/logo.png')}
                />
              </Link>
              {/* end:: Aside header */}

              {/* start:: Aside content */}
              <div className="flex-column-fluid d-flex flex-column justify-content-center">
                <h3 className="font-size-h1 mb-5 text-white">
                  Welcome!
                </h3>
                {/*<p className="font-weight-lighter text-white opacity-80">*/}
                {/*  The ultimate Bootstrap & React 16 admin theme framework for*/}
                {/*  next generation web apps.*/}
                {/*</p>*/}
              </div>
              {/* end:: Aside content */}

              {/* start:: Aside footer for desktop */}
              <div className="d-none flex-column-auto d-lg-flex justify-content-between mt-10">
                <div className="opacity-70 font-weight-bold	text-white">
                  &copy; {copyrightText}
                </div>
                <div className="d-flex">
                  <Link to="#" className="text-white">
                    Privacy
                  </Link>
                  <Link to="#" className="text-white ml-10">
                    Legal
                  </Link>
                  {/*<Link to="#" className="text-white ml-10">*/}
                  {/*  Contact*/}
                  {/*</Link>*/}
                </div>
              </div>
              {/* end:: Aside footer for desktop */}
            </div>
            {/*end: Aside Container*/}
          </div>
          {/*begin::Aside*/}

          {/*begin::Content*/}
          <div className="d-flex flex-column flex-row-fluid position-relative p-7 overflow-hidden">
            {/*begin::Content header*/}
            <div className="position-absolute top-0 right-0 text-right mt-5 mb-15 mb-lg-0 flex-column-auto justify-content-center py-5 px-10">
              <span className="font-weight-bold text-dark-50">
                <FormattedMessage id="AUTH.GENERAL.NO_ACCOUNT" />
              </span>
              <Link
                to={AUTH_SIGN_UP_ROUTE}
                className="font-weight-bold ml-2"
                id="kt_login_signup"
              >
                <FormattedMessage id="AUTH.REGISTER.TITLE" />!
              </Link>
            </div>
            {/*end::Content header*/}

            {/* begin::Content body */}
            <div className="d-flex flex-column-fluid flex-center mt-30 mt-lg-0">
              <Switch>
                <ContentRoute path={AUTH_RESET_CONFIRMATION_ROUTE} component={ResetConfirmation} />
                <ContentRoute path={AUTH_RESET_ROUTE} component={Reset} />
                <ContentRoute path={AUTH_SIGN_IN_ROUTE} component={SignIn} />
                <ContentRoute path={AUTH_SIGN_UP_CONFIRMATION_ROUTE} component={SignUpConfirmation} />
                <ContentRoute path={AUTH_SIGN_UP_ROUTE} component={SignUp} />

                <Redirect from={AUTH_ROUTE} exact={true} to={AUTH_SIGN_IN_ROUTE} />
                <Redirect to={AUTH_SIGN_IN_ROUTE} />
              </Switch>
            </div>
            {/*end::Content body*/}

            {/* begin::Mobile footer */}
            <div className="d-flex d-lg-none flex-column-auto flex-column flex-sm-row justify-content-between align-items-center mt-5 p-5">
              <div className="text-dark-50 font-weight-bold order-2 order-sm-1 my-2">
                &copy; {copyrightText}
              </div>
              <div className="d-flex order-1 order-sm-2 my-2">
                <Link to="#" className="text-dark-75 text-hover-primary">
                  Privacy
                </Link>
                <Link to="#" className="text-dark-75 text-hover-primary ml-4">
                  Legal
                </Link>
                {/*<Link to="#" className="text-dark-75 text-hover-primary ml-4">*/}
                {/*  Contact*/}
                {/*</Link>*/}
              </div>
            </div>
            {/* end::Mobile footer */}
          </div>
          {/*end::Content*/}
        </div>
        {/*end::Sign in*/}
      </div>
    </>
  );
}
